import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDeliveries } from "../../constants";

export const requestCollectMoney = async (
  deliveryId: string
): Promise<void> => {
  return await instance.patch(
    buildUrl(
      ApiRoutesDeliveries.Deliveries,
      deliveryId,
      ApiRoutesDeliveries.CollectMoney
    )
  );
};
